import { render, staticRenderFns } from "./ImageGallerySection.vue?vue&type=template&id=36f647dc&scoped=true"
import script from "./ImageGallerySection.vue?vue&type=script&lang=js"
export * from "./ImageGallerySection.vue?vue&type=script&lang=js"
import style0 from "./ImageGallerySection.vue?vue&type=style&index=0&id=36f647dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f647dc",
  null
  
)

export default component.exports